/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect, useRef, useState } from "react";
import ic_big_help from "../../assets/images/pictures/icon/ic_help_big_circle.svg";
import ic_big_card from "../../assets/images/pictures/icon/ic_big_card.svg";
import ic_big_double_partner from "../../assets/images/pictures/icon/ic_big_2_persons.svg";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import routeVariants from "../../assets/animates/routeVariants";
import Modal from "../global/Modal";
import NavbarBottom from "./../global/NavbarBottom";
import Footer from "./../global/Footer";
import ic_arrow_left from "../../assets/images/pictures/icon/ic_arrow_left_default.svg";

// import SuccessDialog from '../global/SuccessDialog'
// import ErrorDialog from '../global/ErrorDialog'
import SpinnerLoading from "../global/SpinnerLoading";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { postData } from "../../utils/api";

const ContactsContent = () => {
  const [modalOpen, setModalOpen] = useState(false);
  // const [dialogOpen, setDialogOpen] = useState(false);
  // const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isValid, setIsValid] = useState(false);

  const successNotify = () =>
    toast.success(t("success-dialog.message"), {
      position: "bottom-right",
    });

  const failedNotify = () =>
    toast.error(t("error-dialog.message"), {
      position: "bottom-right",
    });

  useEffect(() => {
    if (modalOpen === true) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [modalOpen]);

  // useEffect(() => {
  //   if (dialogOpen === true || errorDialogOpen === true || isLoading === true) {
  //     document.body.style.overflow = "hidden";

  //   } else {
  //     document.body.style.overflow = "auto";
  //   }
  // }, [dialogOpen, errorDialogOpen, isLoading])

  const modalRef = useRef(null);

  const handleOverlayClick = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      setModalOpen(false);
    }
  };

  document.onkeydown = function (evt) {
    if (evt.code === "Escape") {
      setModalOpen(false);
    }
  };

  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [validationMessages, setValidationMessages] = useState({
    name: "",
    email: "",
    message: "",
  });

  useEffect(() => {
    if (
      Object.values(formData).every((value) => value !== "") &&
      Object.values(validationMessages).every((message) => message === "")
    ) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  }, [formData, validationMessages]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if (name === "name") {
      setValidationMessages((prevMessages) => ({
        ...prevMessages,
        name: value.trim() === "" ? t("validation.name-required") : "",
      }));
    }

    if (name === "message") {
      setValidationMessages((prevMessages) => ({
        ...prevMessages,
        message: value.trim() === "" ? t("validation.message-required") : "",
      }));
    }

    if (name === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      setValidationMessages((prevMessages) => ({
        ...prevMessages,
        email:
          !value.trim() === "" || emailRegex.test(value.trim())
            ? ""
            : t("validation.email-invalid"),
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const newValidationMessages = {
      name: "",
      email: "",
      message: "",
    };

    if (!formData.name.trim()) {
      newValidationMessages.name = t("validation.name-required");
    }

    if (!formData.message.trim()) {
      newValidationMessages.message = t("validation.message-required");
    }

    if (!formData.email.trim()) {
      newValidationMessages.email = t("validation.email-required");
    } else if (!emailRegex.test(formData.email.trim())) {
      newValidationMessages.email = t("validation.email-invalid");
    }

    setValidationMessages(newValidationMessages);

    if (!Object.values(newValidationMessages).some((msg) => msg !== "")) {
      const data = {
        name: formData.name,
        email: formData.email,
        message: formData.message,
        type: "Contact Us",
      };

      try {
        setIsLoading(true);
        await fetch("/sendContact", data)
          .then(function (response) {
            if (response.data === "success") {
              setIsLoading(false);
              successNotify();
              setFormData({
                name: "",
                email: "",
                message: "",
              });
              setValidationMessages({
                name: "",
                email: "",
                message: "",
              });
              newValidationMessages.email = "";
              newValidationMessages.message = "";
              newValidationMessages.name = "";
            } else {
              setIsLoading(false);
              failedNotify();
            }
          })
          .catch(function (error) {
            console.log(error);
            setIsLoading(false);
            failedNotify();
          });
      } catch (error) {
        console.error("Error:", error);
        setIsLoading(false);
        failedNotify();
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <>
      <motion.div
        variants={routeVariants}
        initial="initial"
        animate="final"
        id="content"
        className="fs-navigation-overlay-content fs-navigation-overlay-left-content fs-navigation__0 no-transform"
      >
        <div className="contacts-cont bg-color-contact">
          <div className="grey-bg contacts_btn ">
            <div className="container mt-50 px-md-0">
              <div className="row text-center">
                <div className="col-sm-8 col-sm-offset-2">
                  <h2 className="text-center contact-header font-weight-bold mx-auto font-60">
                    {t("contacts-page.contacts-page-content.content-1.heading")}
                  </h2>
                  <p className="contact-subheader">
                    {t(
                      "contacts-page.contacts-page-content.content-1.description"
                    )}
                  </p>
                </div>
              </div>
              <div className="row text-center">
                <div className="col-sm-6 col-md-4">
                  <div className="panel panel-default">
                    <div className="panel-body">
                      <div className="col-sm-6 col-md-8 text-left">
                        <h4 className="">
                          {t(
                            "contacts-page.contacts-page-content.content-2.small-heading-1"
                          )}
                        </h4>
                        <h5 className="">
                          {t(
                            "contacts-page.contacts-page-content.content-2.small-description-1"
                          )}
                        </h5>
                      </div>
                      <div className="col-sm-6 col-md-4 pt-xs-20 pb-10">
                        <div className="ic-box">
                          <img
                            src={ic_big_help}
                            className="attachment-full size-full"
                            alt=""
                            decoding="async"
                            loading="lazy"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="panel-footer">
                      <a
                        href="javascript:;"
                        className="btn-primary font-weight-bold"
                      >
                        {t(
                          "contacts-page.contacts-page-content.content-2.link-1"
                        )}
                        <span>
                          <img
                            src={ic_arrow_left}
                            alt=""
                            className="pl-10 mt--3"
                          />
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-md-4">
                  <div className="panel panel-default">
                    <div className="panel-body">
                      <div className="col-sm-6 col-md-8 text-left">
                        <h4 className="">
                          {t(
                            "contacts-page.contacts-page-content.content-2.small-heading-2"
                          )}
                        </h4>
                        <h5 className="">
                          {t(
                            "contacts-page.contacts-page-content.content-2.small-description-2"
                          )}
                          <br />
                          {t(
                            "contacts-page.contacts-page-content.content-2.small-description-2-1"
                          )}
                        </h5>
                      </div>
                      <div className="col-sm-6 col-md-4 pt-xs-20 pb-10">
                        <div className="ic-box">
                          <img
                            src={ic_big_card}
                            className="attachment-full size-full"
                            alt=""
                            decoding="async"
                            loading="lazy"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="panel-footer">
                      <a
                        onClick={() => setModalOpen(true)}
                        className="btn-primary font-weight-bold"
                      >
                        {t(
                          "contacts-page.contacts-page-content.content-2.link-2"
                        )}
                        <span>
                          <img
                            src={ic_arrow_left}
                            alt=""
                            className="pl-10 mt--3"
                          />
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-md-4">
                  <div className="panel panel-default">
                    <div className="panel-body">
                      <div className="col-sm-6 col-md-8 text-left">
                        <h4 className="">
                          {t(
                            "contacts-page.contacts-page-content.content-2.small-heading-3"
                          )}
                        </h4>
                        <h5 className="">
                          {t(
                            "contacts-page.contacts-page-content.content-2.small-description-3"
                          )}
                        </h5>
                      </div>
                      <div className="col-sm-6 col-md-4 pt-xs-20 pb-10">
                        <div className="ic-box">
                          <img
                            src={ic_big_double_partner}
                            className="attachment-full size-full"
                            alt=""
                            decoding="async"
                            loading="lazy"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="panel-footer">
                      <a
                        href="mailto:info@mobile-id.vn"
                        className="btn-primary font-weight-bold"
                      >
                        {t(
                          "contacts-page.contacts-page-content.content-2.link-3"
                        )}
                        <span>
                          <img
                            src={ic_arrow_left}
                            alt=""
                            className="pl-10 mt--3"
                          />
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container details mt-60" id="contact-info">
            <div className="row">
              <div className="col-md-6 pl-md-0">
                <div className="panel-default bg-primary bor-rad-30 mb-100 ">
                  <div className="panel-body">
                    <p className="text-yellow font-weight-bold pt-16 text-uppercase">
                      {t(
                        "contacts-page.contacts-page-content.content-3.small-heading-1"
                      )}
                    </p>
                    <p className="text-white mx-auto font-weight-bold">
                      Mobile-ID
                    </p>
                    <p className="text-white mx-auto">
                      {t(
                        "contacts-page.contacts-page-content.content-3.small-description-1"
                      )}{" "}
                      0313994173
                    </p>
                    <p className="text-white mx-auto">
                      {t(
                        "contacts-page.contacts-page-content.content-3.small-description-2"
                      )}
                    </p>
                    <p className="text-white mx-auto">
                      {t(
                        "contacts-page.contacts-page-content.content-3.small-description-3"
                      )}
                    </p>
                    {/* <p className='text-white mx-auto'>{t('contacts-page.contacts-page-content.content-3.small-description-4')} <a href="" className='text-white text-deco-white-reverse'>info@mobile-id.vn</a></p> */}
                    <br />

                    <p className="text-yellow font-weight-bold pt-16 text-uppercase">
                      {t(
                        "contacts-page.contacts-page-content.content-3.small-heading-2"
                      )}
                    </p>
                    <p className="text-white mx-auto">
                      {t(
                        "contacts-page.contacts-page-content.content-3.small-description-5"
                      )}
                    </p>

                    <br />
                    <p className="text-yellow font-weight-bold pt-16 text-uppercase">
                      {t(
                        "contacts-page.contacts-page-content.content-3.small-heading-3"
                      )}
                    </p>
                    <p className="text-white mx-auto">
                      {t(
                        "contacts-page.contacts-page-content.content-3.small-description-6"
                      )}{" "}
                      1900 6884{" "}
                    </p>
                    <p className="text-white mx-auto">
                      {t(
                        "contacts-page.contacts-page-content.content-3.small-description-7"
                      )}{" "}
                      +84 28 3622 2982
                    </p>
                    <p className="text-white mx-auto pb-16">
                      Email:{" "}
                      <a
                        href="mailto:info@mobile-id.vn"
                        className="text-white mx-auto text-deco-white-reverse"
                      >
                        info@mobile-id.vn
                      </a>
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 pr-md-0">
                {/* <p className='text-yellow font-weight-bold text-uppercase mx-auto'>{t('contacts-page.contacts-page-content.content-3.contact')}</p> */}
                <h1 className="font-60 font-weight-normal mx-auto">
                  {t(
                    "contacts-page.contacts-page-content.content-3.get-started"
                  )}
                </h1>
                <p className="fill-up-blue pb-24 pt-12">
                  {t("contacts-page.contacts-page-content.content-3.fill-up")}
                </p>
                <form onSubmit={handleSubmit}>
                  <div className="input-form pb-md-50">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder={t(
                          "contacts-page.contacts-page-content.content-3.name"
                        )}
                        style={{ height: "50px" }}
                        value={formData.name}
                        onFocus={(e) => (e.target.placeholder = "")}
                        onBlur={(e) =>
                          (e.target.placeholder = t(
                            "contacts-page.contacts-page-content.content-3.name"
                          ))
                        }
                        onChange={handleInputChange}
                        name="name"
                        id="name"
                      />
                      {validationMessages.name && (
                        <div className="errors--label">
                          {validationMessages.name}
                        </div>
                      )}
                    </div>
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Email"
                        style={{ height: "50px" }}
                        onFocus={(e) => (e.target.placeholder = "")}
                        onBlur={(e) => (e.target.placeholder = "Email")}
                        value={formData.email}
                        onChange={handleInputChange}
                        name="email"
                        id="email"
                      />
                      {validationMessages.email && (
                        <div className="errors--label">
                          {validationMessages.email}
                        </div>
                      )}
                    </div>
                    <div className="form-group">
                      <textarea
                        style={{ resize: "vertical", height: "137px" }}
                        className="form-control"
                        placeholder={t(
                          "contacts-page.contacts-page-content.content-3.message"
                        )}
                        onFocus={(e) => (e.target.placeholder = "")}
                        onBlur={(e) =>
                          (e.target.placeholder = t(
                            "contacts-page.contacts-page-content.content-3.message"
                          ))
                        }
                        value={formData.message}
                        onChange={handleInputChange}
                        name="message"
                        id="message"
                      />
                      {validationMessages.message && (
                        <div className="errors--label">
                          {validationMessages.message}
                        </div>
                      )}
                    </div>
                    <div className="pb-20 flex center">
                      <button
                        type="submit"
                        className="btn-secondary"
                        disabled={!isValid}
                      >
                        {t(
                          "contacts-page.contacts-page-content.content-3.send-message"
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <Footer />
        <NavbarBottom />
      </motion.div>
      {isLoading && <SpinnerLoading />}
      {modalOpen && (
        <Modal
          setOpenModal={setModalOpen}
          handleOverlayClick={handleOverlayClick}
          modalRef={modalRef}
          heading={t("modal.heading-start-with-gopaperless")}
          type="Contact Us - Sales"
        />
      )}
      {/* {dialogOpen && <SuccessDialog setOpenDialog={setDialogOpen} />}
      {errorDialogOpen && <ErrorDialog setOpenDialog={setErrorDialogOpen} />} */}
      <ToastContainer />
    </>
  );
};

export default ContactsContent;
